import React, { useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Table } from "@components/Table";
import { ButtonSecondary, ButtonPrimaryLink } from "@components/Button";
import { deleteUserById } from "@actions/users.action";
import Modal from "@components/Modal";
import { Span } from "@styles/typography";
import { Row, Indent } from "@styles/grid";

const EditUser = ({ userId }) => {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.users.loading);

  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

  const handleDeleteUser = () => async () => {
    try {
      await dispatch(deleteUserById(userId));
      setIsRemoveModalOpen(false);
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return (
    <Row justify="flex-end" padding="0 2rem 0 0">
      <Indent margin="0 1.5rem 0 0">
        <ButtonPrimaryLink uppercase href={`/users/${userId}`} outlined size="small" weight="bold">
          edit
        </ButtonPrimaryLink>
      </Indent>
      <ButtonSecondary uppercase onClick={() => setIsRemoveModalOpen(true)} size="small" weight="bold">
        Remove
      </ButtonSecondary>

      <Modal isOpen={isRemoveModalOpen} onClose={() => setIsRemoveModalOpen(false)} title="Remove User">
        <Indent margin="4rem 0">
          <Span size={1.8}>Are you sure you want to delete this user?</Span>
        </Indent>
        <Row justify="flex-end">
          <Indent margin="0 2rem 0">
            <ButtonSecondary outlined onClick={() => setIsRemoveModalOpen(false)} uppercase>
              Close
            </ButtonSecondary>
          </Indent>
          <ButtonSecondary autoFocus onClick={handleDeleteUser()} uppercase disabled={loading}>
            Remove
          </ButtonSecondary>
        </Row>
      </Modal>
    </Row>
  );
};

const UsersTable = () => {
  const { all, fetching } = useSelector(({ users }) => users);

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "Email",
        accessor: "email",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "Role",
        accessor: "role",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "College",
        accessor: "schools_count",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "Partner",
        accessor: "partner",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "Created At",
        accessor: "created_at",
        isFiltered: true,
        isSorting: true,
      },
      {
        id: "colEdit",
        Cell: ({ row }) => <EditUser userId={row.original.id} />,
      },
    ],
    []
  );

  const data = useMemo(() => all, [all]);

  return <Table columns={columns} data={data} hasGlobalFilter loading={fetching} />;
};

export default UsersTable;
